<template>
  <initio-page-header-and-footer>
    <notfound>
      <div class="container">
        <div class="columns">
          <div class="column is-6 is-centered">
            <div class="content">
              <h1>Uh oh, 404 - Page not found</h1>
              <p><a href="/">Return to homepage</a></p>
            </div>
          </div>
        </div>
      </div>
    </notfound>
  </initio-page-header-and-footer>
</template>

<script>
import InitioPageHeaderAndFooter from '@/components/initio/InitioPageHeaderAndFooter.vue'

export default {
  name: "NotFound",
  components: {
    InitioPageHeaderAndFooter,
  },
};

</script>
